<template>
    <div class="flex flex-col space-y-2">
        <p class="font-medium text-xs text-gray-500">
            <template v-if="first">
                Your payment of <strong class="text-black">{{ amount | money }}</strong>
                will be charged immediately or choose a future date you wish to make the payment on:
            </template>
            <template v-else>
                And then the following payment of <strong class="text-black">{{ amount | money }}</strong>
                will be charged on a future date you choose:
            </template>
        </p>
        <input v-model="value"
            :min="min"
            :max="max"
            type="date"
            :class="{
               [`rounded-lg border-2 py-3 pl-4 pr-4 focus:ring-0 text-sm font-medium text-black`]: true,
               'border-gray-200': ! error,
               'border-red-400 bg-red-200': error,
            }"
            placeholder="Payment Date"
            @input="$emit('input', value)">
        <p v-if="error" class="font-medium text-xs text-red-500" v-text="error" />
        <p v-else class="font-medium text-xs text-gray-500">
            Your Payment Date will be <strong class="text-black">{{ valueAsMoment.format('MMMM Do, YYYY') }}</strong>
        </p>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: {
            date: String,
            amount: {},
            min: String,
            max: String,
            first: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                value: null
            };
        },

        computed: {
            valueAsMoment() {
                return moment(this.value);
            },

            error() {
                if (
                    this.value < this.min
                    || this.value > this.max
                ) {
                    return `Your Payment Date must be between ${moment(this.min).format('L')} and ${moment(this.max).format('L')}`;
                }

                return null;
            }
        },

        watch: {
            date(date, oldDate) {
                this.value = date;
            }
        },

        mounted() {
            this.value = this.date;
        }
    }
</script>
